const recommendList = () => import('@/pages/community/recommend/index.vue');

export default [{
    path: '/community/recommend',
    component: recommendList,
    meta: [{
        name: '社区管理'
    },
    {
        name: '推荐帖子列表',
        activeRoute: '/community/recommend'
    }]
}];